import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-drag-ico",
  "use": "icon-drag-ico-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-drag-ico\"><defs><style></style></defs><path d=\"M896 544H128c-17.68 0-32-14.32-32-32s14.32-32 32-32h768c17.68 0 32 14.32 32 32s-14.32 32-32 32zm0-320H128c-17.68 0-32-14.32-32-32s14.32-32 32-32h768c17.68 0 32 14.32 32 32s-14.32 32-32 32zM128 800h768c17.68 0 32 14.32 32 32s-14.32 32-32 32H128c-17.68 0-32-14.32-32-32s14.32-32 32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol